import { createContext } from "react"

interface Grade {
  id: string
  name: string
  number: number
}

interface Tier {
  id: string
  name: string
  gradeRange: string
  grades: Grade[]
}

interface Referral {
  id: string
  userType: string
  firstName: string
  lastName: string
  phoneNumber: string
  email: string
  grade: { id: string } | null
  referrer: {
    id: string
    firstName: string
    fullName: string
  }
}

export interface RegistrationContextType {
  tiers: Tier[]
  grades: Grade[]
  referral: Referral | null
}

const RegistrationContext = createContext<RegistrationContextType>({
  tiers: [],
  grades: [],
  referral: null,
})

export default RegistrationContext
